export const businessTimeSelector = state => state?.businessTime?.get('results')?.toArray()
